export interface AppUser {
  id: number | null;
  name: string;
  email: string;
  password: string;
  password_confirmation: string | null;
  role: string;
  locale: string;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export class AppUser implements AppUser {
  public id: number | null;
  public name: string;
  public email: string;
  public password: string;
  public password_confirmation: string | null;
  public role: string;
  public locale: string;
  public is_verified: boolean;
  public created_at: string;
  public updated_at: string;

  public constructor() {
    this.id = null;
    this.name = "";
    this.email = "";
    this.password = "";
    this.password_confirmation = "";
    this.role = "";
    this.locale = "hr";
    this.is_verified = false;
    this.created_at = "";
    this.updated_at = "";
  }
}
